<template>
  <div class="d2-plan-card-item" :class="{ 'current': plansListAData.plan_a_text == '使用中' || plansListAData.plan_a_text == 'Using' }">
    <div class="d2-plan-card-name">{{ plansListAData.plan_a_title }}</div>
    <div class="d2-plan-card-price-row"><span class="d2-plan-card-price">${{ plansListAData.plan_a_label_amount }}</span><span class="d2-plan-card-unit">/{{lang['components']['Plan']['PlanA']['time_unit']}}</span></div>
    <ul class="d2-plan-card-features">
      <li v-for="(item, index) in description">
          <i class="fas fa-check"></i> {{ item }}
      </li>
    </ul>
    <button v-if="plansListAData.plan_a_show" class="d2-plan-card-btn upgrade" @click="handleChickPlan(2, 'A', '', 'fb')">
      {{ plansListAData.plan_a_text }}
    </button>
    <button v-else-if="!plansListAData.planHaveBind" class="d2-plan-card-btn upgrade" @click="handleChickPlan(2, 'A', '', 'fb')">
      {{lang['components']['Plan']['PlanA']['is_expired']}}
    </button>
    <button
      v-else
      class="d2-plan-card-btn payagain"
       v-if="isExpiredData && (plansListAData.plan_a_text == '使用中' || plansListAData.plan_a_text == 'Using')"
      @click="handleChickPlan(2, 'A', 'payAgain', 'fb')"
    >
      {{lang['components']['Plan']['PlanA']['plan_item_payagain_button_text']}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'PlanA',
  props: {
    handleChickPlan: {
      type: Function,
      default: () => ({})
    },
    plansListA:{
      type:Object,
      required:true
    },
    isExpired: {
      type: Boolean
    },
    lang: {
      type: Object
    },
  },
  computed: {
    plansListAData: {
      get: function () {
        return this.plansListA
      },
      set: function (value) {
        this.$emit('update:plansListAData', value)
      },
    },
    isExpiredData: {
      get: function () {
        return this.isExpired
      },
      set: function (value) {
        this.$emit('update:isExpiredData', value)
      },
    },
    description: function() {
       return this.plansListA.plan_a_description
    },
    isDisabled: function() {
       return this.plansListA.plan_a_disable
    }
  }
}
</script>

<style lang="scss" scope>
  .plan-A {
    &:hover {
      border: 2px #6298D7 solid;
    }
  }
</style>